import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { System } from '../../shared-components/System';
import { Observable } from 'rxjs';
import { CustomDesignPage } from './models/custom-design-page.model';
import { CSTField } from '../../shared-modules/customization-framework/models/custom-data-field.model';
import { CSTCustomPage } from '../../shared-modules/customization-framework/models/cst-custom-page.model';
import { CustomizationFrameworkService } from '../../shared-modules/customization-framework/customization-framework.service';
import { CSTFieldInUse } from './models/cst-field-in-use.model';

@Injectable()
export class CustomizationService {

    constructor(
        private http: HttpClient,
        private customizationFrameworkService: CustomizationFrameworkService
    ) { }

    getDesignPageByIDs(basePageOnly: boolean = false, pageIDs: number[] = [], includeAllUserPagesForID: boolean = false): Observable<CustomDesignPage[]> {
        return this.customizationFrameworkService.getDesignPageByIDs(basePageOnly, pageIDs, includeAllUserPagesForID);
    }

    saveDesignPage(designPage: CustomDesignPage, basePageOnly: boolean): Observable<CustomDesignPage> {
        const queryString = '?basePageOnly=' + basePageOnly;
        return this.http.post<CustomDesignPage>(System.apiURL.Admin + 'SaveDesignPage' + queryString, designPage);
    }

    saveDesignPageTemplate(designPageTemplate: CustomDesignPage): Observable<CustomDesignPage> {
        return this.http.post<CustomDesignPage>(System.apiURL.Admin + 'SaveDesignPageTemplate', designPageTemplate);
    }

    toggleActiveDesignPageTemplate(designPageTemplateId: number): Observable<CustomDesignPage> {
        const queryString = '?designPageTemplateId=' + designPageTemplateId;
        return this.http.get<CustomDesignPage>(System.apiURL.Admin + 'ToggleActiveDesignPageTemplate' + queryString);
    }

    saveCustomDataField(field: CSTField): Observable<CSTField> {
        return this.http.post<CSTField>(System.apiURL.Admin + 'SaveCustomDataField', field);
    }

    getCustomPages(): Observable<CSTCustomPage[]> {
        return this.http.get<CSTCustomPage[]>(System.apiURL.Admin + 'GetCustomPages');
    }

    saveCustomPage(page: CSTCustomPage): Observable<CSTCustomPage> {
        return this.http.post<CSTCustomPage>(System.apiURL.Admin + 'SaveCustomPage', page);
    }

    customPageNameExists(page: CSTCustomPage): Observable<boolean> {
        return this.http.post<boolean>(System.apiURL.Admin + 'CustomPageNameExists', page);
    }

    getPagesWhereCustomFieldIsUsed(fieldName: string): Observable<CSTFieldInUse[]> {
        const queryString = '?fieldName=' + fieldName;
        return this.http.get<CSTFieldInUse[]>(System.apiURL.Admin + 'GetPagesWhereCustomFieldIsUsed' + queryString);
    }
}